module.exports = __webpack_public_path__ + "static/media/22.9e246c54.jpg";